import { Injectable } from "@angular/core";
import { RestService } from "./rest.service";
import { environment } from "src/environments/environment";
import { HttpHeaders } from "@angular/common/http";

@Injectable()
export class UserInvitationService {

  private baseURL = environment.apiURL;

  constructor(private restService: RestService) {}

  public async inviteNewUser(userInviteRequest: any): Promise<void> {
    this.restService.post<any, any>({
      url: `${this.baseURL}api/user/invite`,
      body: userInviteRequest,
      headers: new HttpHeaders()
    }).subscribe(
      (next) => {
        console.info("user invited successfully, response: ", next);
      },
      (error) => {
        console.log("Failed to invite user, cause: ", error);
      }
    );
  }
}
